import * as t from './actionTypes';

const initialState = {
    loading: true,
    items: [],
}

export default function (state = initialState, action) {
    switch (action.type) {
        case t.LOAD_ITEMS:
            return Object.assign({}, state, {
                items: action.payload
            });
        case t.SET_LOADING:
            return Object.assign({}, state, {
                loading: action.payload
            });
        default:
            return state
    }
}